import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" fill="currentColor" aria-hidden="true"><path d="M17.117.75c.86 0 1.566.683 1.629 1.548l.004.125v15.154c0 .882-.667 1.605-1.512 1.669l-.122.004H2.884c-.861 0-1.567-.683-1.63-1.548l-.004-.125V2.423c0-.882.667-1.605 1.512-1.668L2.884.75h14.232Zm-.859 1.667H3.742c-.42 0-.825.314-.82.738l-.005 13.593c0 .425.308.836.723.836h12.617c.42 0 .826-.282.826-.74V3.254a.83.83 0 0 0-.728-.83l-.098-.006h.001ZM14.583 5.38c.23 0 .417.187.417.417v1a.417.417 0 0 1-.417.416H5.417A.417.417 0 0 1 5 6.797v-1c0-.23.187-.417.417-.417h9.166Zm-5.761 7.673H5.388c-.215 0-.388-.186-.388-.416v-1c0-.23.173-.417.388-.417H8.82a2.5 2.5 0 0 1 4.654 0h1.037a.417.417 0 0 1 .416.417v1a.417.417 0 0 1-.416.416h-1.037a2.5 2.5 0 0 1-4.653 0Zm2.326-1.75a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z" fill="#333" fillRule="nonzero" /></svg>

const ProfileConfig = React.forwardRef((props, ref) => {
  return (
    <IconBase name="profile-config" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

ProfileConfig.displayName = 'IconProfileConfig'

export default ProfileConfig
